import React, {
  FC, useEffect, useState,
} from 'react';
import { Cab, ParcelUser } from '../../../../../lib/types';
import CheckPhone from './CheckPhone';
import SubmitForm from './SubmitForm';
import RegisterSuccess from '../RegisterSuccess';

const Register: FC<Props> = ({
  onClose,
  isEnglish,
  setIsEnglish,
  cab,
  setShowLoading,
  // 注册成功后的回调函数，如果设置了该回调函数，则会在注册成功后调用该函数，不显示注册成功页面
  handleSubmit,
  needCheckPhone,
  registerPhone,
}) => {
  const [phoneCheck, setPhoneCheck] = useState<boolean>();
  const [phoneNumber, setPhoneNumber] = useState<number>();
  const [registerSuccess, setRegisterSuccess] = useState<boolean>(false);
  const [orderIdList, setOrderIdList] = useState<number[]>([]);
  const [cabOrderBoxMap, setCabOrderBoxMap] = useState<{ [key: number]: { boxCount: number; orderBoxList: string[] } }>();
  const [userId, setUserId] = useState<number>();
  const [registerUserInfo, setRegisterUserInfo] = useState<ParcelUser>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // 如果不需要验证手机号，则直接跳转到提交表单页面
    if (needCheckPhone === false) {
      setPhoneCheck(true);
    }
  }, [needCheckPhone]);

  useEffect(() => {
    // 只有免检用户才支持，如果传入了注册手机号，则设置手机号
    if (needCheckPhone === false && registerPhone) {
      setPhoneNumber(registerPhone);
    }
  }, [needCheckPhone, registerPhone]);

  return (
    <>
      {
        !registerSuccess && (
          <>
            {
              (!phoneCheck || !phoneNumber) && (
                <CheckPhone
                  isEnglish={isEnglish}
                  setIsEnglish={setIsEnglish}
                  cab={cab}
                  setShowLoading={setShowLoading}
                  phoneCheck={phoneCheck}
                  setPhoneCheck={setPhoneCheck}
                  setPhoneNumber={setPhoneNumber}
                  onClose={onClose}
                />
              )
            }
            {
              phoneCheck && phoneNumber && (
                <SubmitForm
                  onClose={onClose}
                  isEnglish={isEnglish}
                  setIsEnglish={setIsEnglish}
                  cab={cab}
                  setShowLoading={setShowLoading}
                  setRegisterSuccess={() => {
                    if (handleSubmit) {
                      handleSubmit();
                    }
                    else {
                      setRegisterSuccess(true);
                    }
                  }}
                  phoneNumber={phoneNumber}
                  setOrderIdList={setOrderIdList}
                  setUserId={setUserId}
                  registerUserInfo={registerUserInfo}
                  setCabOrderBoxMap={setCabOrderBoxMap}
                  setRegisterUserInfo={setRegisterUserInfo}
                />
              )
            }
          </>
        )
      }

      {
        registerSuccess && (
          <RegisterSuccess
            onClose={() => {
              setRegisterSuccess(false);
            }}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            cab={cab}
            orderIdList={orderIdList}
            cabOrderBoxMap={cabOrderBoxMap}
            setShowLoading={setShowLoading}
            userId={userId}
            registerUserInfo={registerUserInfo}
          />
        )
      }
    </>
  );
};

export interface Props {
  onClose: () => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cab: Cab;
  setShowLoading: (isShow: boolean) => void;
  handleSubmit?: () => void;
  // 是否需要验证手机号
  needCheckPhone?: boolean;
  // 注册手机号
  registerPhone?: number;
}

export default Register;
